import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import CategoryIcon from '@material-ui/icons/Category';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AreYouSure from '../core/AreYouSure';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import { globalStyles as styles } from '../core/style/gstheme';
import GS from '../grafsync/grafsync';
import AnnotateCleanupIcon from '../core/icons/AnnotateCleanUp';

const ADD_DEFAULT_CLASS = "addClasses";
const MATERIALISE = "materialise";
const ANNOTATE_CLEANUP = "datasetAnnotationCleanup";

class DatasetBatchOperations extends Component {

  constructor(props) {
    super(props);
    this.state = {
      areYouSure: false,
      operation: "",
      sureMessage: []
    };
  }

  checkIfSure = (operation, sureMessage) => this.setState({ areYouSure: true, sureMessage, operation });

  onNotSure = () => this.setState({ areYouSure: false, sureMessage: [], operation: "" });

  onSure = async () => {
    this.setState({ areYouSure: false, sureMessage: [] });
    try {
      // We need to ensure messages are processed or batch lock will cause rejection
      await GS.waitForEditsToClear();
      await GS.operate("batchupdateDataProject", this.props.graph, {
        action: this.state.operation,
        component: this.props.datasetIRI
      });
    }
    catch (e) {
      this.setState({ isErrored: { message: "Cannot perform operation." } });
    }
  };

  render() {

    const { areYouSure, sureMessage } = this.state;
    const { defaultClasses, isReadOnly, annotate } = this.props;

    return (
      <ProjectConsumer>
        {({ ontologyProjectAssociation }) => (
          <div style={{ padding: 30, float: 'right' }}>
            <div>
              <div style={{ textAlign: 'right', marginBottom: 36 }}>
                {!isReadOnly && defaultClasses && defaultClasses.length > 0 &&
                  <span style={{ marginRight: 12 }}>
                    <Tooltip title="Add default classes to all resources that are in the dataset">
                      <IconButton data-test="add-default-class" size="small" onClick={() => this.checkIfSure(ADD_DEFAULT_CLASS,
                        [
                          "This operation will add any default classes defined for the dataset to all resources that have an 'In Dataset' value that is this dataset.",
                          "This is a batch operation and will lock the project."
                        ])}>
                        <CategoryIcon />
                      </IconButton>
                    </Tooltip>
                  </span>
                }
                {!isReadOnly && ontologyProjectAssociation && ontologyProjectAssociation.length > 0 &&
                  <span style={{ marginRight: 12 }}>
                    <Tooltip title="Synchronise all inverse and symmetric relationships">
                      <IconButton data-test="materialise" size="small" onClick={() => this.checkIfSure(MATERIALISE,
                        [
                          "This operation will add any missing inverse and symmetric relationships on resources that are in the dataset.",
                          "Note that this will only apply to relationships that are wholly within the dataset or outbound from the resoures in this dataset.",
                          "If there are other datasets with outbound symmetric or inverse relationships that target resources in this dataset, you will need to process them separately.",
                          "This is a batch operation and will lock the project."
                        ])}>
                        <SyncProblemIcon />
                      </IconButton>
                    </Tooltip>
                  </span>
                }
                  {!isReadOnly && annotate &&
                    <span style={{ marginRight: 12 }}>
                      <Tooltip title="Remove all unconnected annotations">
                        <IconButton data-test="annotate-cleanup" size="small" onClick={() => this.checkIfSure(ANNOTATE_CLEANUP,
                          [
                            "This operation will remove any annotations that are no longer connected for this dataset.",
                            "This is a batch operation and will lock the project."
                          ])}>
                          <AnnotateCleanupIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  }
              </div>
            </div>
            {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message={sureMessage} />}
          </div>
        )}
      </ProjectConsumer>
    );
  }
}

DatasetBatchOperations.propTypes = {
  classes: PropTypes.object,
  entitlements: PropTypes.array.isRequired,
  project: PropTypes.string.isRequired,
  defaultClasses: PropTypes.array,
  graph: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  datasetIRI: PropTypes.string,
  useWorkflow: PropTypes.bool,
  annotate: PropTypes.bool,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  iriOptions: PropTypes.object
};

export default withStyles(styles)(DatasetBatchOperations);